<template>
<button
    type="submit"
    :style="buttonStyle"
    :disabled="disabled"
    @click="clickHandler($event)"
>
    <slot name="clicked" v-if="clicked">
        <template v-if="clickText">{{ clickText }}</template>
        <i v-else class="far fa-circle-notch less-jumpy-spin-animation"></i>
    </slot>
    <slot v-else></slot>
</button>
</template>

<script>
export default {
    name: 'button-once',

    props: {
        waitFor: {
            type: Number,
            default: function () {
                return window.buttonOnceDefaults.waitFor;
            }
        },
        clickText: {
            // If value is loose false, we use a Font Awesome spinner
            type: String,
            default: function () {
                return window.buttonOnceDefaults.clickText;
            }
        },
        handler: {
            type: Function,
            default: function () {
                //
            }
        }
    },

    data: function () {
        return {
            /**
             * Width style value of the button.
             *
             * @type String
             */
            width: null,

            /**
             * Has the button been clicked?
             *
             * @type Boolean
             */
            clicked: false,

            /**
             * Has the button been disabled?
             *
             * @type Boolean
             */
            disabled: false,
        };
    },

    computed: {
        buttonStyle: function () {
            if (this.width && this.isNumeric(this.width)) {
                return {
                    width: `${this.width}px`
                };
            }

            return {};
        }
    },

    methods: {
        isNumeric: function (n) {
            return isNaN(parseFloat(n)) === false
                && isFinite(n);
        },

        clickHandler: function (event) {
            // Prevents further clicks while clicked is true
            if (this.clicked) {
                event.preventDefault();
                return;
            }

            // Maintain the buttons width before showing the clicked content
            this.width = this.$el.offsetWidth;
            this.clicked = true;

            // Disabling will prevent form submission, make sure we're leaving first before disabling
            window.onbeforeunload = () => {
                this.disabled = true;
                return undefined;
            };

            // If it hasn't happened in 2 seconds, it's not happening
            // Also, if a browser stops supporting 'beforeunload', we
            // still need to prevent multiple clicks for a short time
            setTimeout(() => {
                this.clicked = this.disabled;
                this.width = this.clicked ? this.width : null;
            }, this.waitFor);

            this.handler(event, this);
        },

        disable: function () {
            this.width = this.$el.offsetWidth;
            this.clicked = this.disabled = true;
        },

        enable: function () {
            this.reset();
        },

        reset: function () {
            this.width = null;
            this.clicked = false;
            this.disabled = false;
        },
    },
}
</script>

<style scoped>
    .less-jumpy-spin-animation {
        -webkit-animation: spin 2s infinite linear;
           -moz-animation: spin 2s infinite linear;
             -o-animation: spin 2s infinite linear;
                animation: spin 2s infinite linear;
    }

    @-moz-keyframes spin {
        0% {
            -moz-transform: rotate(0deg);
        }
        100% {
            -moz-transform: rotate(359deg);
        }
    }

    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(359deg);
        }
    }

    @-o-keyframes spin {
        0% {
            -o-transform: rotate(0deg);
        }
        100% {
            -o-transform: rotate(359deg);
        }
    }

    @keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
                    transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(359deg);
                    transform: rotate(359deg);
        }
    }
</style>
